var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062",
    transform: "translate(-1027 -1432)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_457",
    "data-name": "Ellipse 457",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(1027 1432)",
    fill: "#e5eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "humor",
    transform: "translate(1057 1468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M41,2V13c0,19-19,32-19,32S3,32,3,13V2A40.793,40.793,0,0,0,41,2Z",
    fill: "#207bbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M34.306,17.72a6.253,6.253,0,0,0-8.611,0l-1.389-1.439a8.273,8.273,0,0,1,11.389,0Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M18.306,17.72a6.253,6.253,0,0,0-8.611,0L8.306,16.28a8.273,8.273,0,0,1,11.389,0Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M28,30a10,10,0,0,1-12,0s2,5,6,5S28,30,28,30Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M61,19V30c0,19-19,32-19,32S23,49,23,30V19A40.793,40.793,0,0,0,61,19Z",
    fill: "#ffe181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M54.306,34.72a6.253,6.253,0,0,0-8.611,0l-1.389-1.439a8.273,8.273,0,0,1,11.389,0Z",
    fill: "#207bbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M38.306,34.72a6.253,6.253,0,0,0-8.611,0l-1.389-1.439a8.273,8.273,0,0,1,11.389,0Z",
    fill: "#207bbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M48,47a10,10,0,0,1-12,0s2,5,6,5S48,47,48,47Z",
    fill: "#207bbd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestOne);
export default __webpack_public_path__ + "static/media/test-one.9d8c10f084b3b09e03d5f38656df81e3.svg";
export { ForwardRef as ReactComponent };